import http from '@/assets/common/http';
// ------------------------------------------退货审核
// ------------------------------------------查询未退货订单功能
export function queryReturnWareFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 46,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取销售退货单详情
export function returnWareFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 50,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取采购退货出库单
export function queryPurchaseReturnStockOutListFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 51,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取采购退货单
export function queryReturnProductFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 91,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出采购退货单
export function exportListHttp(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 72,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 采购退货单结算单打印
export function invoicesPrint(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 21,
    ...data,
  };
  return http.post(params);
}
// 查询采购退货出库单详情
export function getPurchaseReturnStockOutDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 52,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询采购退货单详情
export function returnProductFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 92,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询销售退货单详情
export function salesReturnDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 94,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 从销售退货单退库
export function salesReturnWarehouseFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 95,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询销售退库单
export function salesReturnWarehouseListFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 96,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询销售退库单详情
export function salesReturnWarehouseDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 97,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 销售报表(拉取界面)
export function salesStatements(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 20,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导出
export function exportForm(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 21,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导出（采购）
// p_salesStatements
export function p_exportForm(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 23,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 拉取界面
export function p_salesStatements(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 22,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 毛利表（筛选 拉取）
export function queryProfit(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 24,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 毛利表（导出 汇总）
export function summary(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 25,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 毛利表（导出 明细）
export function detail(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 26,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 月报表明细
export function exportDetail(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 28,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取客户毛利表
export function queryTCProfit(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 31,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导入毛利表
export function exportTCTable(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 32,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导出退货销售单
// 导出
export function exportReturnForm(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 63,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导出老表
export function exportOldDetail(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 42,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 明细老表
export function exportOldMonthDetail(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 43,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 导出出库统计表
export function exportReturnDocForm(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 79,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 采购退货出库单-导出结算单
export function purchaseReturnStockOutSettlementExport(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 25,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/returnWare.js